import { tools } from '@worktango/ai-assistant/react';
import { actionsMutations, ActionInputs } from '~/behaviors/mutations/actions.mutations';

export const createAction = tools.createTool({
  name: 'create_action',
  description: 'Create an action/task based on the user input',
  displayName: 'Creating an action item',
  pastTenseDisplayName: 'Created action item',
  parameters: (t) =>
    t.Object({
      action: t.Object({
        libraryActionId: t.Optional(
          t.Number({
            description: 'The library action id',
          }),
        ),
        translations: t.Object({
          en_ca: t.Optional(
            t.Object({
              title: t.String({
                description: 'The title of the action, in English (en_ca)',
              }),
              description: t.Optional(
                t.String({
                  description: 'The description of the action, in English (en_ca)',
                }),
              ),
            }),
          ),
          fr_ca: t.Optional(
            t.Object({
              title: t.String({
                description: 'The title of the action, in French (fr_ca)',
              }),
              description: t.Optional(
                t.String({
                  description: 'The description of the action, in French (fr_ca)',
                }),
              ),
            }),
          ),
          es_es: t.Optional(
            t.Object({
              title: t.String({
                description: 'The title of the action, in Spanish (es_es)',
              }),
              description: t.Optional(
                t.String({
                  description: 'The description of the action, in Spanish (es_es)',
                }),
              ),
            }),
          ),
        }),
        dueAt: t.Optional(
          t.String({
            description: 'The due date of the action. The format is yyyy-MM-dd',
          }),
        ),
        surveyIds: t.Optional(
          t.Array(
            t.Number({
              description: 'The survey ids of the action',
            }),
          ),
        ),
        userId: t.Number({
          description: 'The user id of the action',
        }),
        categoryIds: t.Optional(
          t.Array(
            t.Number({
              description: 'The category ids of the action',
            }),
          ),
        ),
      }),
    }),
  fulfill: async (args) => {
    try {
      // Replacing _ with - in the translations keys
      // Doing this as it is not possible to use - in the keys without it being transformed into _
      Object.keys(args.action.translations).forEach((key) => {
        args.action.translations[key.replace('_', '-')] = args.action.translations[key];
        delete args.action.translations[key];
      });

      const action = await actionsMutations.createAction({
        libraryActionId: args.action.libraryActionId ?? null,
        translations: args.action.translations as ActionInputs['translations'],
        dueAt: args.action.dueAt ?? null,
        surveyIds: args.action.surveyIds ?? null,
        userId: args.action.userId,
        categoryIds: args.action.categoryIds ?? null,
      });

      const actionUrl = getActionUrl(action.id);

      return `Created action. Tell the user the action URL: [${actionUrl}](${actionUrl}). Action data: ${JSON.stringify(action, null, 2)}`;
    } catch (error) {
      return `Failed to create action. Don't reveal code related errors to the user, just the context of the error. ${error}`;
    }
  },
});

function getActionUrl(actionId: string) {
  return `${window.location.origin}/action-planning/actions/${actionId}`;
}
